import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Folder — front flap eases open on a loop. Baseline is drawn closed
 *  so reduced-motion still reads as "folder". Origin is the hinge at
 *  bottom-left so the flap opens without the body shifting. */
export function IcnFolder(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="folder">
      {/* Back body */}
      <path d="M2 5 h4 l1.5 1.5 h4.5 a1 1 0 0 1 1 1 v5 a1 1 0 0 1 -1 1 h-9 a1 1 0 0 1 -1 -1 v-7 a1 1 0 0 1 1 -1 z" />
      {/* Front flap — rotates open/close on a 3.2s loop */}
      <path
        d="M2.5 8 h10 l-1 4.5 a1 1 0 0 1 -1 0.5 h-8 a1 1 0 0 1 -1 -1 z"
        style={{ transformOrigin: '2.5px 13.5px' }}
      >
        {animate && (
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0;-14;-14;0;0"
            keyTimes="0;0.25;0.55;0.85;1"
            dur="3.2s"
            repeatCount="indefinite"
          />
        )}
      </path>
    </Svg>
  );
}
